import { Component } from '@angular/core';
import { RaUiLoadingSpinnerModule } from '@ra-web-tech-ui-toolkit/components';
@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],

  imports: [RaUiLoadingSpinnerModule],
})
export class SpinnerComponent {}
